function MFRAnchorLinks(index, element) {
  this.$element = $(element)

  this.selectors = {
    filters: ".links",
    firstEntry: ".entry-content > section:first-child",
    secondEntry: ".entry-content > section:nth-last-child(2)",
    thirdEntry: ".entry-content > section:nth-child(3)",
    footerEntry: ".footer"
  }

  this.init()
}

MFRAnchorLinks.prototype = Object.assign({}, MFRAnchorLinks.prototype, {
  init: function () {
    this.$filters = $(this.selectors.filters)
    this.$firstEntry = $(this.selectors.firstEntry)
    this.$secondEntry = $(this.selectors.secondEntry)
    this.$thirdEntry = $(this.selectors.thirdEntry)
    this.$footerEntry = $(this.selectors.footerEntry)
    
    $(window).on("scroll", this.__anchorBarStates.bind(this))
  },

  __anchorBarStates: function() {
    if (this.$thirdEntry.visible(true)) {
      this.$filters.addClass('fixed')
    }

    if (this.$secondEntry.visible(true)) {
      this.$filters.addClass('fixed')
    }

    if (this.$footerEntry.visible(true)) {
      this.$filters.removeClass('fixed')
    }

    if (this.$firstEntry.visible(true)) {
      this.$filters.removeClass('fixed')
    }
  }
})